<template>
  <b-modal
    id="register-modal"
    centered
    ref="register-modal"
    :title="modalTitle"
    cancel-title="انصراف"
    ok-title="ثبت نام"
    @ok="checkForm"
  >
    <form ref="form" @submit.stop.prevent="checkForm">
      <b-form-group
        :state="!nameHasError"
        :label="nameLabel"
        label-for="name-input"
        :invalid-feedback="emailErrorMessage"
      >
        <b-form-input
          id="name-input"
          type="name"
          :placeholder="namePlaceholder"
          name="name"
          v-model="name"
          @keyup="checkNameOnKeyUp(name)"
          :state="!nameHasError"
          required
          is-invalid="true"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        :state="!surnameHasError"
        :label="surnameLabel"
        label-for="surname-input"
        :invalid-feedback="emailErrorMessage"
      >
        <b-form-input
          id="surname-input"
          type="surname"
          :placeholder="surnamePlaceHolder"
          surname="surname"
          v-model="surname"
          @keyup="checkSurnameOnKeyUp(surname)"
          :state="!surnameHasError"
          required
          is-invalid="true"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        :state="!emailHasError"
        :label="emailLabel"
        label-for="email-input"
        :invalid-feedback="emailErrorMessage"
      >
        <b-form-input
          id="email-input"
          type="email"
          :placeholder="emailPlaceholder"
          name="emailName"
          v-model="email"
          @keyup="checkEmailOnKeyUp(email)"
          :state="!emailHasError"
          required
          is-invalid="true"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        :state="!passwordHasError"
        :label="passwordLabel"
        label-for="password-input"
        :invalid-feedback="passwordErrorMessage"
      >
        <b-form-input
          id="password-input"
          type="password"
          :placeholder="passwordPlaceholder"
          name="password"
          v-model="password"
          @keyup="checkPasswordOnKeyUp(password)"
          :state="!passwordHasError"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        :state="!repeatPasswordHasError"
        :label="repeatPasswordLabel"
        label-for="password-input"
        :invalid-feedback="repeatPasswordErrorMessage"
      >
        <b-form-input
          id="confirm-password-input"
          type="password"
          :placeholder="repeatPasswordPlaceholder"
          name="password"
          v-model="password_confirmation"
          @keyup="checkRepeatPasswordOnKeyUp(password_confirmation)"
          :state="!repeatPasswordHasError"
          required
        ></b-form-input>
      </b-form-group>
    </form>
  </b-modal>
</template>

<script>
import { isValidEmail } from "../../validators";

export default {
  name: "registration-component",

  data() {
    return {
      modalTitle: "ثبت نام",
      modalTitleRegistered: "ثبت نام شده",
      primaryBtnLabel: "ثبت",
      nameLabel: "نام",
      surnameLabel: "نام مستعار",
      emailLabel: "ایمیل",
      passwordLabel: "کلمه عبور",
      repeatPasswordLabel: "تکرار کلمه عبور",
      btnRegisteredLabel: "ثبت نام",
      namePlaceholder: "نام",
      surnamePlaceHolder: "نام مستعار",
      emailPlaceholder: "ایمیل",
      passwordPlaceholder: "کلمه عبور",
      repeatPasswordPlaceholder: "تکرار کلمه عبور",
      notEqualErrorMessage: "تکرار کلمه عبور یکسان نیست",
      passwordErrorMessage: "کلمه عبور ضروری است",
      repeatPasswordErrorMessage: "تکرار کلمه عبور ضروری است",
      nameErrorMessage: "نام ضروری است",
      surnameErrorMessage: "نام مستعار ضروری است",
      emailErrorMessage: "ایمیل ضروری است",
      emailNotValidErrorMessage: "ایمیل نا معتبر است",
      name: "",
      surname: "",
      email: "",
      password: "",
      password_confirmation: "",
      nameHasError: null,
      surnameHasError: null,
      emailHasError: null,
      passwordHasError: null,
      repeatPasswordHasError: null,
      isFormSuccess: false,
      isUserSignedUp: false,
    };
  },

  computed: {},

  methods: {

    closeModal() {
      this.$refs["register-modal"].hide();
      this.$store.commit("showSignupModal", false);
    },
    checkForm(e) {
      e.preventDefault();

      if (
        this.name &&
        this.surname &&
        this.email &&
        this.password &&
        this.password_confirmation
      ) {
        this.emailHasError = false;
        this.surnameHasError = false;
        this.passwordHasError = false;
        this.isFormSuccess = true;
        this.$store
          .dispatch("register", {
            name: this.name,
            surname: this.surname,
            email: this.email,
            password: this.password,
            password_confirmation: this.password_confirmation,
          })
          .then((data) => {
            this.isUserSignedUp = true;
            this.closeModal();
          })
          .catch((e) => {
            this.isUserSignedUp = false;
          });
      }

      if (!this.name) {
        this.nameHasError = true;
      } else {
        this.nameHasError = false;
      }

      if (!this.surname) {
        this.surnameHasError = true;
      } else {
        this.surnameHasError = false;
      }

      if (!this.email) {
        this.emailHasError = true;

        if (this.email && !isValidEmail(this.email)) {
          this.emailErrorMessage = this.emailNotValidErrorMessage;
        }
      } else {
        this.emailHasError = false;
      }

      if (!this.password) {
        this.passwordHasError = true;
      } else {
        this.passwordHasError = false;
      }

      if (!this.password_confirmation) {
        this.repeatPasswordHasError = true;
      } else {
        this.repeatPasswordHasError = false;
      }
    },
    checkNameOnKeyUp(nameValue) {
      if (nameValue) {
        this.nameHasError = false;
      } else {
        this.nameHasError = true;
      }
    },

    checkSurnameOnKeyUp(surname) {
      if (surname) {
        this.surnameHasError = false;
      } else {
        this.surnameHasError = true;
      }
    },

    checkEmailOnKeyUp(emailValue) {
      if (emailValue && isValidEmail(emailValue)) {
        this.emailHasError = false;
      } else {
        this.emailHasError = true;

        if (!isValidEmail(emailValue)) {
          this.emailErrorMessage = this.emailNotValidErrorMessage;
        }
      }
    },

    checkPasswordOnKeyUp(passwordValue) {
      if (passwordValue) {
        this.passwordHasError = false;

        if (this.password_confirmation === this.password) {
          this.passwordHasError = false;
        } else {
          this.passwordHasError = true;
        }
      } else {
        this.passwordHasError = true;
      }
    },

    checkRepeatPasswordOnKeyUp(repeatPasswordValue) {
      if (repeatPasswordValue) {
        if (repeatPasswordValue === this.password) {
          this.repeatPasswordHasError = false;
        } else {
          this.repeatPasswordHasError = true;
        }
      } else {
        this.repeatPasswordHasError = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fa-exclamation-circle {
  color: red;
}
.fa-check {
  color: green;
}
</style>


